export default {
  warning:
    'Denne butik er ikke tilknyttet et brand. For at systemet fungerer korrekt, skal butikken tilhøre et. Føj denne butik til et brand.',
  cta: 'Gå til brands',
};
